<template>
  <div class="user-row">
    <div class="bubble">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'AiChatUserMessage',
  props: {
    text: { type: String, default: '' },
  },
};
</script>

<style scoped lang="scss">
.user-row {
  display: flex;
  justify-content: flex-end;
  margin: 18px 0;
}
.bubble {
  background: var(--ai-user-bubble);
  color: var(--ai-text);
  border-radius: 22px;
  padding: 10px 18px;
  max-width: 80%;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.55;
  font-size: 15px;
}
</style>
